import { MAX_TO } from '@weft/types';
import { isNotNullOrUndefined } from '@weft/utils';
import { formatNumber } from '@weft/utils';
import { INFINITY_SYMBOL } from 'apps/app/src/assets/components/design/symbols/infinity-symbol';

type TableToCellProps = {
  to: number | undefined;
  className?: string;
};

export const TableToCell:React.FC<TableToCellProps> = ({ to, className }) => {
  const isMaxValue = isNotNullOrUndefined(to) && to >= MAX_TO;
  
  return (
    <p className={className}>      
      {isMaxValue ? INFINITY_SYMBOL : formatNumber(to)}
    </p>
  );
};